// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mi-3";
export var downloadButton = "_mi-4";
export var fileContainer = "_mi-9 _mi-7";
export var fileContainerBase = "_mi-7";
export var fileContainerFixedHeight = "_mi-8 _mi-7";
export var fileInfo = "_mi-5";
export var fileInfoWidthRestricted = "_mi-6";
export var fileType = "_mi-1";
export var fileTypeName = "_mi-2";
export var image = "_mi-0";
export var link = "_mi-b";
export var overflowEllipsis = "_mi-a";